module.exports = __webpack_public_path__ + "static/media/features_img.19318716.png";